module.exports = __webpack_public_path__ + "img/userbg.4dbc8e08.png";